import HttpProxy from '@/services/HttpProxy';

export default class HomeService {
  static async Dashboard(parameters) {
    const response = await HttpProxy.submit({
      method: 'get',
      url: 'Orders/Dashboard',
      parameters,
    });
    return response?.data ?? null;
  }

   static async GetBusinessInfoCloseDay(parameters) {
    const response = await HttpProxy.submit({
      method: 'get',
      url: 'BusinessInfo/CloseDay',
      parameters,
    });
    return response?.data ?? null;
  }

   static async PostRevertClosedDaily(parameters) {
    const response = await HttpProxy.submit({
      method: 'post',
      url: 'BusinessInfo/CloseDayRevert',
      parameters,
    });
    return response?.data ?? null;
  }
}
